// extracted by mini-css-extract-plugin
module.exports = {"stopBuild":"StopBuild__stopBuild--PY","icon":"StopBuild__icon--A3","stopIcon":"StopBuild__stopIcon--El","invisible":"StopBuild__invisible--bg"};